<template>
  <v-btn-toggle
    v-if="buttonList && buttonList.length"
    v-model="toggleIndex"
    :class="[
      'segmented-button--container',
      disabled ? 'segmented-button--disabled' : null,
    ]"
    mandatory
    @change="buttonToggled"
  >
    <v-btn
      v-for="(button, i) in buttonList"
      :key="i"
      :disabled="disabled"
      text
      class="segmented-button--btn"
      :ripple="{ center: true }"
    >
      {{ button.text }}
    </v-btn>
  </v-btn-toggle>
</template>

<script>
export default {
  name: 'AscSegmentedButton',

  props: {
    buttonList: {
      type: Array,
      default: () => [],
    },
    onChange: {
      type: Function,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    selectedIndex: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      toggleIndex: this.selectedIndex,
    }
  },

  watch: {
    selectedIndex(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.toggleIndex = newValue
      }
    },
  },

  methods: {
    buttonToggled() {
      this.onChange(this.toggleIndex)
    },
  },
}
</script>

<style lang="scss">
.segmented-button {
  &--container {
    border-radius: 2px;
    box-shadow: none;
    max-height: 32px;
  }

  &--disabled {
    cursor: not-allowed;
  }

  &--btn {
    /* background-color: $primary-white; */
    flex-grow: 1;
    text-align: center;
    max-height: 30px;
    max-width: 113px !important;
    opacity: 1 !important;
    padding: 0 10.5px 0 9.5px !important;

    &::before {
      opacity: 0;
      color: $accent-200;
    }

    &.v-btn.theme--light {
      color: $primary-black;

      &:hover {
        background-color: $accent-0;
      }

      .v-btn__content {
        z-index: 1;
      }

      &.v-btn--active {
        background-color: $accent-200;

        .v-ripple__container {
          color: transparent !important;
        }
      }

      &:not(.v-btn--active) {
        .v-ripple__container {
          color: $accent-200 !important;

          & > span {
            opacity: 1 !important;
          }
        }
      }

      &.v-btn--disabled {
        color: $primary-black !important;

        &.v-btn {
          opacity: 0.5 !important;

          &--active {
            opacity: 0.5;
          }
        }
      }
    }
  }
}
</style>
